import UserInfoForm from './userInfoForm'

export default UserInfoForm
